"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailView = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Navigation_1 = require("../Navigation");
var DetailView = function (_a) {
    var children = _a.children, icon = _a.icon, title = _a.title, subtitle = _a.subtitle;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col" }, { children: [(0, jsx_runtime_1.jsxs)(Navigation_1.ToolBar, { children: [icon ? (0, jsx_runtime_1.jsx)(Navigation_1.BarItem, { icon: icon, mode: "secondary", disabled: true }, void 0) : null, (0, jsx_runtime_1.jsx)(Navigation_1.BarHeader, { primary: title, secondary: subtitle }, void 0), (0, jsx_runtime_1.jsx)(Navigation_1.BarSpacer, {}, void 0)] }, void 0), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex-grow p-4" }, { children: children }), void 0)] }), void 0));
};
exports.DetailView = DetailView;
